export default __webpack_public_path__ + "static/media/grillz-cabinet.9c6831ee.png";